import { Fragment, memo } from 'react';

import { isEmpty, isNonNullish } from 'remeda';

import { StoreProductCard } from './storeProductCard/StoreProductCard';

import css from './StoreProducts.module.css';

import { EmptyPlaceholder } from 'v2/components/emptyPlaceholder/EmptyPlaceholder';
import { Loader } from 'v2/components/loader/Loader';
import { StoreProductModel } from 'v2/types/StoreModel';

interface StoreProductsProps {
  isLoading: boolean;
  data?: StoreProductModel[];
  onRevalidate: VoidFunction;
}

export const StoreProducts = memo<StoreProductsProps>(({ isLoading, data, onRevalidate }) => {
  if (isLoading) {
    return <Loader />;
  }

  return (
    isNonNullish(data) && (
      <Fragment>
        {isEmpty(data) ? (
          <EmptyPlaceholder />
        ) : (
          <div className={css.storeProductCards}>
            {data.map((product) => (
              <StoreProductCard key={product.id} product={product} onRevalidate={onRevalidate} />
            ))}
          </div>
        )}
      </Fragment>
    )
  );
});

StoreProducts.displayName = 'StoreProducts';
